'use strict';

angular.module('app.information.privacy_page', [])
.config([
  '$stateProvider', 'PRODUCT', function($stateProvider, product) {
    return $stateProvider.state('app.information.privacy', {
      url: '/information/privacy',
      templateUrl: 'assets/templates/' + product.Code + '/information/privacyView.html',
      title: 'Privacy'
    });
  }
]);


// WEBPACK FOOTER //
// ./app.v2/components/information/privacy/privacy.js